import { render, staticRenderFns } from "./MediaDetails.vue?vue&type=template&id=588bc80a"
import script from "./MediaDetails.vue?vue&type=script&lang=js"
export * from "./MediaDetails.vue?vue&type=script&lang=js"
import style0 from "./MediaDetails.vue?vue&type=style&index=0&id=588bc80a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports